"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFocusVisible = void 0;
var react_1 = require("react");
var useFocusVisible = function (target, onBlur, onFocus) {
    var _a = react_1.useState(true), isFocusVisible = _a[0], setIsFocusVisible = _a[1];
    var _b = react_1.useState(true), focusVisible = _b[0], setFocusVisible = _b[1];
    var _c = react_1.useState(false), focused = _c[0], setFocused = _c[1];
    var focusFunction = function (event) {
        if (onFocus)
            onFocus(event);
        setIsFocusVisible(true);
        setFocused(true);
    };
    var blurFunction = function (event) {
        if (onBlur)
            onBlur(event);
        setIsFocusVisible(false);
        setFocused(false);
    };
    react_1.useEffect(function () {
        setIsFocusVisible(focusVisible);
    }, [focused, focusVisible]);
    // KeyboardEvent
    var keyboardEventHandler = react_1.useCallback(function () {
        setFocusVisible(true);
    }, []);
    // MouseEvent
    var mouseEventHandler = react_1.useCallback(function () {
        setFocusVisible(false);
    }, []);
    var useEvent = function (event, callback) {
        react_1.useEffect(function () {
            var current = target.current;
            current.addEventListener(event, callback);
            return function () { return current.removeEventListener(event, callback); };
        }, [event, callback]);
    };
    useEvent('mousedown', mouseEventHandler);
    useEvent('mouseup', mouseEventHandler);
    useEvent('keydown', keyboardEventHandler);
    useEvent('keyup', keyboardEventHandler);
    return { isFocusVisible: isFocusVisible, focusFunction: focusFunction, blurFunction: blurFunction };
};
exports.useFocusVisible = useFocusVisible;
//# sourceMappingURL=useFocusVisible.js.map